export type MusicTrack = {
 id: string; name: string; genre: string; mood: string; target_bpm: number; description: string;
 state: string; storage_path: string; duration_seconds: number | null; deleted_at?: string | null;
};
export type MusicSortKey = 'name' | 'genre' | 'mood' | 'target_bpm' | 'duration_seconds' | 'state';
export const MUSIC_COLUMNS: { key: MusicSortKey; label: string }[] = [
 {key:'name',label:'Music'}, {key:'genre',label:'Style'}, {key:'mood',label:'Mood / feel'},
 {key:'target_bpm',label:'Target BPM'}, {key:'duration_seconds',label:'Duration'}, {key:'state',label:'Status'},
];
export function filterMusic(tracks: readonly MusicTrack[], query: string, genre: string, state: string, deleted = false) {
 const q=query.trim().toLowerCase();
 return tracks.filter(t=>Boolean(t.deleted_at)===deleted&&(!genre||t.genre===genre)&&(!state||t.state===state)&&
  `${t.name} ${t.genre} ${t.mood} ${t.description}`.toLowerCase().includes(q));
}
export type MusicImpact = {id:string;screenplay_count:number;deleted:boolean;revision:string};
export function validMusicImpact(value:unknown,id:string):value is MusicImpact {
 if(!value||typeof value!=='object')return false;
 const v=value as MusicImpact;
 return v.id===id&&Number.isSafeInteger(v.screenplay_count)&&v.screenplay_count>=0&&typeof v.deleted==='boolean'&&typeof v.revision==='string'&&/^[a-f0-9]{32}$/.test(v.revision);
}
export function musicRemovalWarning(screenplays:number) {
 return screenplays>0?`Warning: this music is used in ${screenplays} ${screenplays===1?'screenplay':'screenplays'}. Existing uses will retain access to the audio.`:'No saved screenplay references were found for this music.';
}
export function musicDuration(seconds: number | null) {
 if(seconds==null||!Number.isFinite(seconds)||seconds<=0)return '—';
 const whole=Math.round(seconds);return `${Math.floor(whole/60)}:${String(whole%60).padStart(2,'0')}`;
}
